(function () {
  'use strict';

  function initRail(root) {
    if (!root || root.dataset.initialized === 'true') return;

    var track = root.querySelector('[data-banner-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-banner-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-banner-dot]'));
    var previous = root.querySelector('[data-banner-prev]');
    var next = root.querySelector('[data-banner-next]');
    var autoplay = root.dataset.autoplay === 'true';
    var interval = Math.max(parseInt(root.dataset.interval, 10) || 6000, 3000);
    var index = 0;
    var timer = null;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!track || slides.length < 1) return;

    root.dataset.initialized = 'true';

    function update(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = 'translate3d(-' + (index * 100) + '%, 0, 0)';
      slides.forEach(function (slide, slideIndex) {
        slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
      });
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (autoplay && !reducedMotion && slides.length > 1) {
        timer = window.setInterval(function () {
          update(index + 1);
        }, interval);
      }
    }

    if (previous) {
      previous.addEventListener('click', function () {
        update(index - 1);
        startAutoplay();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        update(index + 1);
        startAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        update(parseInt(dot.dataset.bannerDot, 10) || 0);
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) startAutoplay();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    update(0);
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-cranbi-banner-rail]').forEach(initRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
